const translations = {
    'th': {
        "home": {
            "link": "/", 
            "title": "หน้าแรก"
        },
        "concept": {
            "link": "/concept", 
            "title": "แนวคิด"
        },
        "scienceschool": {
            "link": "/science-school", 
            "title": "โรงเรียนวิทยาศาสตร์"
        },
        "aboutus": {
            "link": "/about-us", 
            "title": "เกี่ยวกับเรา"
        },
        "curriculum": {
            "link": "/curriculum", 
            "title": "หลักสูตร"
        },
        "boards": {
            "link": "/boards", 
            "title": "ผู้บริหาร"
        },
        "admissions": {
            "link": "/admissions", 
            "title": "ระเบียบการ"
        },
        "contactus": {
            "link": "/contact-us", 
            "title": "ติดต่อเรา"
        },
    },
    'en': {
        "home": {
            "link": "/en/", 
            "title": "Home"
        },
        "concept": {
            "link": "/en/concept", 
            "title": "Concept"
        },
        "scienceschool": {
            "link": "/en/science-school", 
            "title": "Science School"
        },
        "aboutus": {
            "link": "/en/about-us", 
            "title": "About Us"
        },
        "curriculum": {
            "link": "/en/curriculum", 
            "title": "Curriculum"
        },
        "boards": {
            "link": "/en/boards", 
            "title": "Boards of Trustees"
        },
        "admissions": {
            "link": "/en/admissions", 
            "title": "Admissions"
        },
        "contactus": {
            "link": "/en/contact-us", 
            "title": "Contact Us"
        },
    }
}

const getTranslation = language => {
    return translations[language];
}

const initialState = {
    language: 'th',
    prop: getTranslation('th'),
    page: "home",
};

const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
const CHANGE_PAGE = "CHANGE_PAGE";
const RESET_RELOAD = "RESET_RELOAD";

export const changeLanguage = language => ({
    type: CHANGE_LANGUAGE, language, prop: getTranslation(language),
});

export const changePage = page => ({
    type: CHANGE_PAGE, page,
})

export const resetReload = () => ({
    type: RESET_RELOAD
})

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return { ...state, language: action.language, prop: action.prop, reload: true };
        case CHANGE_PAGE:
            return { ...state, page: action.page, reload: false };
        case RESET_RELOAD:
            return { ...state, reload: false };
        default:
            return state;
    }
};